import { queryOptions } from "@tanstack/react-query";

import {
  getCoachEmailDoNotDisturbFn,
  getCoachEmailPreferencesFn,
  getOwnTimeZoneFn,
} from "~/lib/functions/account-settings";

export const accountSettingsKeys = {
  all: ["account-settings"] as const,
  timeZone: () => [...accountSettingsKeys.all, "time-zone"] as const,
  emailPreferences: () =>
    [...accountSettingsKeys.all, "email-preferences"] as const,
  emailDoNotDisturb: () =>
    [...accountSettingsKeys.all, "email-do-not-disturb"] as const,
};

export const ownTimeZoneQueryOptions = () =>
  queryOptions({
    queryKey: accountSettingsKeys.timeZone(),
    queryFn: () => getOwnTimeZoneFn(),
  });

export const coachEmailPreferencesQueryOptions = () =>
  queryOptions({
    queryKey: accountSettingsKeys.emailPreferences(),
    queryFn: () => getCoachEmailPreferencesFn(),
  });

/**
 * A GoHighLevel read, so it is never in the loader and never retried: while
 * it is pending or failed, the page just shows no notice.
 */
export const coachEmailDoNotDisturbQueryOptions = () =>
  queryOptions({
    queryKey: accountSettingsKeys.emailDoNotDisturb(),
    queryFn: () => getCoachEmailDoNotDisturbFn(),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
